import { TExternalDigitalQueuesStoreState } from './types';

export const DEFAULT_EXTERNAL_DIGITAL_QUEUES_STORE_STATE: TExternalDigitalQueuesStoreState = { manifests: null };
